import { useAppTranslation } from '../i18n/useAppTranslation';
import React, { useState } from "react";
import { useMediaQuery } from "@mui/material";
import { Pause, PlayArrow } from "@mui/icons-material";
import "./AuthLogo.css";

export default function AuthLogo() {
  const { tr } = useAppTranslation();
  const reducedMotion = useMediaQuery("(prefers-reduced-motion: reduce)");
  const [motionChoice, setMotionChoice] = useState<boolean | null>(null);
  const playing = motionChoice ?? !reducedMotion;

  return (
    <div className={`auth-logo ${playing ? "auth-logo-playing" : ""}`}>
      <div className="auth-logo-halo" aria-hidden="true" />
      <div className="auth-logo-stage">
        <img
          className="auth-logo-image"
          src="/g1s-logo-3d.png"
          alt="G1Sport"
          width="555"
          height="710"
        />
      </div>
      <div className="auth-logo-shadow" aria-hidden="true" />
      <button
        className="auth-logo-motion"
        type="button"
        aria-pressed={playing}
        aria-label={playing ? tr("Mettre le logo en pause") : tr("Animer le logo")}
        title={playing ? tr("Mettre le logo en pause") : tr("Animer le logo")}
        onClick={() => setMotionChoice(!playing)}
      >
        {playing ? (
          <Pause fontSize="inherit" />
        ) : (
          <PlayArrow fontSize="inherit" />
        )}
        <span>{playing ? tr("Pause") : tr("Animer")}</span>
      </button>
    </div>
  );
}
